module.exports = __webpack_public_path__ + "img/tijari.0aa677bf.png";